/*
  Responsive image component.
  Details in /README.md
 */

import * as React from 'react';
import breakpoints from '../../../breakpoints';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import './styles.scss';

const defaultWidth = '1000';
const defaultLowQualityWidth = '20';
const defaultAspectRatio = '16x9';
const mobileImageTriggerWidthDefault = breakpoints.md;
const imageQuality = 80;

const aspectRatioMap = {
  '2x1': 0.5,
  '16x9': 0.5625,
  '3x2': 0.667,
  '4x3': 0.75,
  '1x1': 1,
  '4x5': 1.2,
  '2x3': 1.5,
  '6x1': 0.59,
  '6x7-promo': 1.16,
};

interface ImageProps {
  url: string;
  alt: string;
  aspectRatio?: '2x1' | '16x9' | '3x2' | '4x3' | '1x1' | '4x5' | '2x3' | '6x1' | '6x7-promo';
  focalPoint?: string | null;
  cropTo?: string | undefined;
  lowQualityWidth?: string;
  widthSizes?: string[];
  aspectRatioMobile?: '2x1' | '16x9' | '3x2' | '4x3' | '1x1' | '4x5' | '2x3' | '6x1' | '6x7-promo';
  mobileImageTriggerWidth?: number;
  isLoaded?: Function;
  hasTransparentBackground?: boolean;
  isDarkened?: boolean;
}

const Image = ({
  url,
  alt,
  aspectRatio = defaultAspectRatio,
  aspectRatioMobile,
  mobileImageTriggerWidth = mobileImageTriggerWidthDefault,
  cropTo = undefined,
  widthSizes = [defaultWidth],
  lowQualityWidth = defaultLowQualityWidth,
  isLoaded,
  hasTransparentBackground = false,
  focalPoint,
  isDarkened = false, // passed as percentage 80 etc.
}: ImageProps) => {
  const setAspectRatio = () => {
    if (!aspectRatioMobile) return aspectRatio;
    return window.innerWidth < mobileImageTriggerWidth ? aspectRatioMobile : aspectRatio;
  };

  return (
    <picture
      className={
        `responsive-image ${aspectRatio ? `responsive-image--${aspectRatio}` : ''}
        ${aspectRatioMobile ? `responsive-image--mobile-${aspectRatioMobile}` : ''}
        ${hasTransparentBackground ? 'responsive-image--transparent' : ''}`
      }
    >
      {aspectRatioMobile && (
        <source
          media={`(max-width: ${mobileImageTriggerWidth}px )`}
          data-sizes="auto"
          data-srcset={
            widthSizes.map((widthSize) => (
              // @ts-ignore
              `${url}?fit=thumb&q=${imageQuality}&f=${cropTo || ''}&fl=progressive&w=${widthSize}&h=${Math.ceil(parseInt(widthSize, 10) * aspectRatioMap[aspectRatioMobile])} ${widthSize}w`
            ))
          }
        />
      )}

      <img
        onLoad={() => {
          if (isLoaded) {
            isLoaded();
          }
        }}
        data-sizes="auto"
        style={{ objectPosition: focalPoint || 'initial' }}
        // @ts-ignore
        data-src={`${url}?fit=thumb&w=${lowQualityWidth}&f=${cropTo || ''}&h=${Math.ceil(parseInt(lowQualityWidth, 10) * aspectRatioMap[setAspectRatio()])}`}
        data-srcset={
          widthSizes.map((widthSize) => (
            // @ts-ignore
            `${url}?fit=thumb&q=${imageQuality}&f=${cropTo || ''}&fl=progressive&w=${widthSize}&h=${Math.ceil(parseInt(widthSize, 10) * aspectRatioMap[aspectRatio])} ${widthSize}w`
          ))
        }
        className={`lazyload  blur-up ${isDarkened ? 'has-opacity' : ''}`}
        alt={alt || 'image with no description'}
      />
    </picture>
  );
};

export default Image;
